import type { AllRouteEndpoints } from "../routeTypes";

export const postAppGroupIdFigmaFileNodesCacheKeys: AllRouteEndpoints[] = [];
